const CREDS_PREFIX = "itpmng_aws_creds_";
const REGION_KEY = "itpmng_aws_default_region";
const DEFAULT_REGION = "eu-west-1";

export interface AwsCreds {
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken: string;
}

export const getAwsCreds = (accountAlias: string): AwsCreds | null => {
  const raw = sessionStorage.getItem(CREDS_PREFIX + accountAlias);
  return raw ? JSON.parse(raw) : null;
};

export const setAwsCreds = (accountAlias: string, creds: AwsCreds): void =>
  sessionStorage.setItem(CREDS_PREFIX + accountAlias, JSON.stringify(creds));

export const clearAwsCreds = (accountAlias: string): void =>
  sessionStorage.removeItem(CREDS_PREFIX + accountAlias);

export const getDefaultRegion = (): string =>
  localStorage.getItem(REGION_KEY) || DEFAULT_REGION;

export const setDefaultRegion = (region: string): void =>
  localStorage.setItem(REGION_KEY, region);
